<template>
    <div :class="['contact', { 'is-mobile': isMobile }]">
        <section class="section-1" ref="sec1">
            <h3>品牌合作</h3>
            <div class="input_wrap">
                <div>
                    <label for="name">姓名/Name<i>*</i></label><span class="error_tip" v-if="err.name">请填写姓名</span>
                </div>
                <input :disabled="success" v-model="form.name" type="text" id="name" :maxlength="20" autocomplete="off"
                    @change="changeName" />
            </div>
            <div class="input_wrap">
                <div><label for="company">公司名称/Company</label></div>
                <input :disabled="success" v-model="form.company" type="text" id="company" :maxlength="30"
                    autocomplete="off" />
            </div>
            <div class="input_wrap">
                <div>
                    <label for="phone">电话/Tel<i>*</i></label><span class="error_tip" v-if="err.phone">请填写正确的电话号码</span>
                </div>
                <input :disabled="success" v-model="form.phone" type="text" id="phone" :maxlength="11"
                    autocomplete="off" @change="changePhone" />
            </div>
            <div class="input_wrap">
                <div><label for="email">合作内容</label></div>
                <input :disabled="success" v-model="form.email" type="text" id="email" :maxlength="50"
                    autocomplete="off" />
            </div>
            <div class="submit_err_tip" v-show="errMsg">{{ errMsg }}</div>

            <div class="button" :class="{ disabled: success }" @click="submit">
                {{ success ? "提交成功" : "提交" }}
            </div>
        </section>
        <Foot></Foot>
    </div>
</template>

<script>
import { isMobile } from "@/js/utils";
import axios from 'axios';

export default {
    components: {
        Foot: () => import("@/components/footer.vue"),
    },
    data() {
        return {
            isMobile: false,
            success: false,
            errMsg: '',
            err: {
                phone: false,
                name: false,
            },

            form: {
                name: '',
                email: '',
                phone: '',
                company: ''
            }
        };
    },

    mounted() {
        this.isMobile = window.innerWidth <= 600 || isMobile();

        window.addEventListener("resize", this.resize);
    },

    methods: {
        resize() {
            this.isMobile = window.innerWidth <= 600 || isMobile();
        },

        changeName() {
            if (this.form.name.trim()) {
                this.err.name = false
            } else {
                this.err.name = true
            }
        },

        changePhone() {
            let reg = /^1[0-9]{10}$|^0[1-9]{10}$/
            this.err.phone = !reg.test(this.form.phone)
        },

        async submit() {
            this.errMsg = false
            if (this.success) return
            if (this.form.name && this.form.phone && !this.err.phone && !this.err.name) {
                let data = {
                    name: this.form.name,
                    phone: this.form.phone,
                    email: this.form.email,
                    company: this.form.company,
                    type: 2
                }

                let res = await axios.post('https://website.map.airlook.com/api/map/website/server/commitData', data)

                if (res.data.code == 200) {
                    this.success = true
                } else {
                    this.errMsg = res.data.msg
                    this.success = false
                }
            } else {
                this.changeName()
                this.changePhone()
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.resize);
    },
};
</script>


<style lang="scss" scoped>
.contact {
    color: #fff;

    &:not(.is-mobile) {
        background: #000 url("../assets/image/contact/bg.png") no-repeat center top;
        background-size: 100%;
        overflow: hidden;

        .section-1 {
            padding-top: 160px;
            width: 800px;
            margin: 0 auto;
            overflow: hidden;

            h3 {
                font-size: 40px;
                color: #fff;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                line-height: 40px;
                letter-spacing: 1px;
                text-align: center;
                margin-bottom: 62px;
            }

            .input_wrap {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin-bottom: 20px;

                div {
                    margin-bottom: 21px;
                }
            }

            label,
            .error_tip {
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #828282;
                line-height: 20px;
            }

            i,
            .submit_err_tip {
                color: #c30101;
                font-size: 14px;
                padding-left: 5px;
            }

            .submit_err_tip {
                position: absolute;
            }

            .error_tip {
                font-size: 12px;
                font-weight: 500;
                padding-left: 24px;
                color: #c23936;
            }

            input {
                border: 0;
                line-height: 40px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #fff;
                padding-left: 10px;
                background: rgba(255, 255, 255, 0.23);
                border-radius: 2px;
                backdrop-filter: blur(10px);

                &:-internal-autofill-selected {
                    background: none !important;
                    appearance: none;
                }

                &:focus {
                    outline: none;
                }

                &[disabled] {
                    opacity: 0.8;
                }
            }

            .button {
                width: 120px;
                height: 40px;
                margin: 80px auto;
                background: #ffffff;
                border-radius: 20px;
                color: #000;
                line-height: 40px;
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                text-align: center;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }

                &.disabled {
                    opacity: 0.6;
                    cursor: default;

                    &:hover {
                        opacity: 0.6;
                    }
                }
            }
        }
    }

    &.is-mobile {
        padding-top: 50px;
        -webkit-tap-highlight-color: transparent;
        background: #000 url("../assets/image/contact/bg_m.png") no-repeat center top;
        background-size: 100%;
        overflow: hidden;

        .section-1 {
            padding-top: 60px;
            width: calc(100% - 60px);
            margin: 0 auto;
            overflow: hidden;

            h3 {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                line-height: 25px;
                letter-spacing: 1px;
                text-align: center;
                margin-bottom: 30px;
                color: #fff;
            }

            .input_wrap {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin-bottom: 16px;

                div {
                    margin-bottom: 8px;
                }
            }

            label,
            .error_tip {
                font-size: 12px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 500;
                color: #828282;
                line-height: 17px;
            }

            .error_tip {
                padding-left: 24px;
                color: #C23936;
            }

            i,
            .submit_err_tip {
                color: #C30101;
                font-size: 14px;
                padding-left: 5px;
            }

            .submit_err_tip {
                position: absolute;
            }

            input {
                border: 0;
                line-height: 40px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                height: 40px;
                background: rgba(255, 255, 255, 0.23);
                border-radius: 2px;
                backdrop-filter: blur(10px);
                padding-left: 10px;
                color: #fff;

                &:-internal-autofill-selected {
                    background: none !important;
                    appearance: none;
                }

                &:focus {
                    outline: none;
                }

                &[disabled] {
                    opacity: 0.8
                }
            }

            .button {
                width: 100px;
                height: 36px;
                margin: 60px auto 90px;
                background: #ffffff;
                border-radius: 20px;
                color: #000;
                line-height: 36px;
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                text-align: center;
                letter-spacing: 2px;
                cursor: pointer;

                &:hover {
                    opacity: 0.8
                }

                &.disabled {
                    opacity: 0.6;
                    cursor: default;

                    &:hover {
                        opacity: 0.6;
                    }
                }
            }
        }
    }
}
</style>